import {config} from '../config';

export default {
    getEnableCortezSupport: () => config.data.deviceSupport.enableCortezSupport,
    getEnableCosmosSupport: () => config.data.deviceSupport.enableCosmosSupport,
    getEnableDeltaSupport: () => config.data.deviceSupport.enableDeltaSupport,
    getEnableOrdinarySupport: () => config.data.deviceSupport.enableOrdinarySupport,
    getEnableP4Support: () => config.data.deviceSupport.enableP4Support,
    getEnableSoyuzSupport: () => config.data.deviceSupport.enableSoyuzSupport,
    getEnableArianeSupport: () => config.data.deviceSupport.enableArianeSupport,
    getEnableVespucciSupport: () => config.data.deviceSupport.enableVespucciSupport,
    getEnableVoyagerSupport: () => config.data.deviceSupport.enableVoyagerSupport,
    getEnableOriginalOneSupport: () => config.data.deviceSupport.enableOriginalOneSupport,
    getEnableOriginalDuoSupport: () => config.data.deviceSupport.enableOriginalDuoSupport,
    getEnableHermesPrimeSupport: () => config.data.deviceSupport.enableHermesPrimeSupport,
    getEnableHermesMidSupport: () => config.data.deviceSupport.enableHermesMidSupport,
    getEnableJunoSupport: () => config.data.deviceSupport.enableJunoSupport,
};
